import { render } from "./Remanejamento.vue?vue&type=template&id=686a7595&scoped=true"
import script from "./Remanejamento.vue?vue&type=script&lang=js"
export * from "./Remanejamento.vue?vue&type=script&lang=js"

import "./Remanejamento.vue?vue&type=style&index=0&id=686a7595&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686a7595"]])

export default __exports__